module.exports = __webpack_public_path__ + "img/client-1.jpg?5fb5e21d9aee8676ccb8d9162ef50302";